export const Separator = () => {
    return <span className="opacity-60 text-slate-700 dark:text-portfolio-white">|</span>;
};
